export default "__VITE_ASSET__D15KzFJI__"